import { render } from "./EmaiVerification.vue?vue&type=template&id=3695490c"
import script from "./EmaiVerification.vue?vue&type=script&lang=js"
export * from "./EmaiVerification.vue?vue&type=script&lang=js"

import "./EmaiVerification.vue?vue&type=style&index=0&id=3695490c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__